import { LandingPropertyService } from "./../../landing-property.service";
import { Component, Input, OnInit } from "@angular/core";
import { PropertyService } from "app/modules/admin/properties/property.service";

@Component({
  selector: "app-rating",
  templateUrl: "./rating.component.html",
  styleUrls: ["./rating.component.scss"],
})
export class RatingComponent implements OnInit {
  @Input() properties: any[];
  @Input() propertyIndex: number;
  stars = Array(5).fill(0);
  hoverIndexes: number[] = [];

  constructor(private landing_property_service: LandingPropertyService) {}

  ngOnInit(): void {}

  onHover(propertyIndex: number, starIndex: number): void {
    this.hoverIndexes[propertyIndex] = starIndex;
  }

  resetHover(propertyIndex: number): void {
    this.hoverIndexes[propertyIndex] = -1;
  }

  isRemoving(propertyIndex: number, starIndex: number): boolean {
    return (
      this.hoverIndexes[propertyIndex] !== -1 &&
      this.hoverIndexes[propertyIndex] < this.properties[propertyIndex].valoracion &&
      starIndex > this.hoverIndexes[propertyIndex]
    );
  }

  handleClick(event: MouseEvent, propertyIndex: number, starIndex: number): void {
    const rect = (event.target as HTMLElement).getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const isLeftHalf = clickX < rect.width / 2;

    // Si es la mitad izquierda, asignamos el valor actual + 0.5
    // Si es la mitad derecha, asignamos el valor actual + 1
    const rating = starIndex + (isLeftHalf ? 0.5 : 1);

    // Convertimos el rating a una escala de 0 a 10
    const ratingScale10 = rating * 2;

    this.calificar(this.properties[propertyIndex].id, ratingScale10);
  }

  calificar(propertyId: number, rating: number): void {
    const propertyClient = this.properties.find((property) => property.id === propertyId);
    if (propertyClient) {
      const valoracionActual = propertyClient.valoracion;
      propertyClient.valoracion = rating;
      const data = {
        client_property_id: propertyId,
        valoracion: rating,
      };
      this.landing_property_service.setValoracion(data).then(
        (response) => {},
        (error) => {
          console.error(error);
          propertyClient.valoracion = valoracionActual;
        }
      );
    }
  }

  isFullStar(propertyIndex: number, starIndex: number): boolean {
    // Convertimos el rating de escala 0-10 a escala 0-5
    const rating = this.properties[propertyIndex].valoracion / 2;
    return rating >= starIndex + 1;
  }

  isHalfStar(propertyIndex: number, starIndex: number): boolean {
    // Convertimos el rating de escala 0-10 a escala 0-5
    const rating = this.properties[propertyIndex].valoracion / 2;
    return rating > starIndex && rating < starIndex + 1;
  }

  isEmptyStar(propertyIndex: number, starIndex: number): boolean {
    // Convertimos el rating de escala 0-10 a escala 0-5
    const rating = this.properties[propertyIndex].valoracion / 2;
    return rating <= starIndex;
  }
}
